import { List } from 'immutable'
import { useSelector } from 'react-redux'

export const useLangDirection = () =>
  useSelector((state) => {
    let projectDirection = state.getIn(['project', 'Settings', 'isRTL'], false)
    let pageID = state.get('page')
    let pageDirection = state
      .getIn(['project', 'Pages'], List())
      .find((page) => page.get('_id') === pageID)
      ?.get?.('direction', '')
    if (pageDirection) {
      return pageDirection === 'ltr' ? false : pageDirection === 'rtl' ? true : false
    } else {
      return projectDirection
    }
  })
